'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _ActiveCurrencyCode = require('pricing-pages-unified-ui/reducers/ActiveCurrencyCode');

var _ActiveCurrencyCode2 = _interopRequireDefault(_ActiveCurrencyCode);

var _ActiveHub = require('pricing-pages-unified-ui/reducers/ActiveHub');

var _ActiveHub2 = _interopRequireDefault(_ActiveHub);

var _Auth = require('pricing-pages-unified-ui/reducers/Auth');

var _Auth2 = _interopRequireDefault(_Auth);

var _AuthState = require('pricing-pages-unified-ui/reducers/AuthState');

var _AuthState2 = _interopRequireDefault(_AuthState);

var _AvailableTrials = require('pricing-pages-unified-ui/reducers/AvailableTrials');

var _AvailableTrials2 = _interopRequireDefault(_AvailableTrials);

var _BillingTerms = require('pricing-pages-unified-ui/reducers/BillingTerms');

var _BillingTerms2 = _interopRequireDefault(_BillingTerms);

var _Config = require('pricing-pages-unified-ui/reducers/Config');

var _Config2 = _interopRequireDefault(_Config);

var _Country = require('pricing-pages-unified-ui/reducers/Country');

var _Country2 = _interopRequireDefault(_Country);

var _CustomerCurrencyCode = require('pricing-pages-unified-ui/reducers/CustomerCurrencyCode');

var _CustomerCurrencyCode2 = _interopRequireDefault(_CustomerCurrencyCode);

var _NumContactsInCrm = require('pricing-pages-unified-ui/reducers/NumContactsInCrm');

var _NumContactsInCrm2 = _interopRequireDefault(_NumContactsInCrm);

var _Parcels = require('pricing-pages-unified-ui/reducers/Parcels');

var _Parcels2 = _interopRequireDefault(_Parcels);

var _Merchandise = require('pricing-pages-unified-ui/reducers/Merchandise');

var _Merchandise2 = _interopRequireDefault(_Merchandise);

var _ProductBasedOffers = require('pricing-pages-unified-ui/reducers/ProductBasedOffers');

var _ProductBasedOffers2 = _interopRequireDefault(_ProductBasedOffers);

var _PurchaseMotionsByLocation = require('pricing-pages-unified-ui/reducers/PurchaseMotionsByLocation');

var _PurchaseMotionsByLocation2 = _interopRequireDefault(_PurchaseMotionsByLocation);

var _RequiredOnboarding = require('pricing-pages-unified-ui/reducers/RequiredOnboarding');

var _RequiredOnboarding2 = _interopRequireDefault(_RequiredOnboarding);

var _Settings = require('pricing-pages-unified-ui/reducers/Settings');

var _Settings2 = _interopRequireDefault(_Settings);

var _UsersInPortal = require('pricing-pages-unified-ui/reducers/UsersInPortal');

var _UsersInPortal2 = _interopRequireDefault(_UsersInPortal);

var _Promotions = require('pricing-pages-unified-ui/reducers/Promotions');

var _Promotions2 = _interopRequireDefault(_Promotions);

var _PhoneNumbers = require('pricing-pages-unified-ui/reducers/PhoneNumbers');

var _PhoneNumbers2 = _interopRequireDefault(_PhoneNumbers);

var _ExperimentTreatments = require('pricing-pages-unified-ui/reducers/ExperimentTreatments');

var _ExperimentTreatments2 = _interopRequireDefault(_ExperimentTreatments);

var _PurchaseMotionRequestStatus = require('pricing-pages-unified-ui/reducers/PurchaseMotionRequestStatus');

var _PurchaseMotionRequestStatus2 = _interopRequireDefault(_PurchaseMotionRequestStatus);

var _OnboardingTasks = require('pricing-pages-unified-ui/reducers/OnboardingTasks');

var _OnboardingTasks2 = _interopRequireDefault(_OnboardingTasks);

var _CompletedOnboardingTasks = require('pricing-pages-unified-ui/reducers/CompletedOnboardingTasks');

var _CompletedOnboardingTasks2 = _interopRequireDefault(_CompletedOnboardingTasks);

var _CustomerDemographics = require('pricing-pages-unified-ui/reducers/CustomerDemographics');

var _CustomerDemographics2 = _interopRequireDefault(_CustomerDemographics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  activeCurrencyCode: _ActiveCurrencyCode2.default,
  auth: _Auth2.default,
  authState: _AuthState2.default,
  availableTrials: _AvailableTrials2.default,
  billingTerms: _BillingTerms2.default,
  config: _Config2.default,
  activeHub: _ActiveHub2.default,
  country: _Country2.default,
  customerCurrencyCode: _CustomerCurrencyCode2.default,
  merchandise: _Merchandise2.default,
  parcels: _Parcels2.default,
  settings: _Settings2.default,
  numContactsInCrm: _NumContactsInCrm2.default,
  purchaseMotionsByLocation: _PurchaseMotionsByLocation2.default,
  productBasedOffers: _ProductBasedOffers2.default,
  requiredOnboarding: _RequiredOnboarding2.default,
  usersInPortal: _UsersInPortal2.default,
  promotions: _Promotions2.default,
  phoneNumbers: _PhoneNumbers2.default,
  experimentTreatments: _ExperimentTreatments2.default,
  purchaseMotionRequestStatus: _PurchaseMotionRequestStatus2.default,
  // Mon153 reducers
  onboardingTasks: _OnboardingTasks2.default,
  completedOnboardingTasks: _CompletedOnboardingTasks2.default,
  customerDemographics: _CustomerDemographics2.default
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/index.js
// module id = 376
// module chunks = 3 4 5